import React, { Component } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";

export default class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: 3,
      hover: 3
    };
    this.handleHover = this.handleHover.bind(this);
  }

  render() {
    const { navHeight, cards } = this.props;
    const { clicked, hover } = this.state;
    return (
      <TitleWrap navHeight={navHeight}>
        {cards.map((c, i) => {
          return (
            <ContentCard
              key={i * 31}
              onClick={() => this.setState({ clicked: i })}
              clicked={clicked}
              number={i}
              color={c.color}
              hover={hover}
              onMouseEnter={() => this.handleHover(i)}
              onMouseLeave={() => this.handleHover(i)}
            >
              <Content clicked={clicked} number={i}>
                <Logo
                  clicked={clicked}
                  number={i}
                  src={c.backLogo}
                  alt="logo"
                />
                <Text clicked={clicked} number={i}>
                  {c.text}
                  {c.link.length > 0 && (
                    <span>
                      Erfahren Sie mehr auf unserer{" "}
                      <a href={c.link}>Webseite</a>.
                    </span>
                  )}
                </Text>
              </Content>
              <Center clicked={clicked} number={i}>
                <FontAwesomeIcon
                  size="lg"
                  style={{ marginTop: "calc(45vh)" }}
                  icon={clicked < i ? faChevronRight : faChevronLeft}
                />
              </Center>
            </ContentCard>
          );
        })}
        <Down clicked={clicked}>
          <FontAwesomeIcon size="lg" icon={faChevronDown} color={"#fff"} />
        </Down>
      </TitleWrap>
    );
  }

  handleHover(i) {
    this.setState(prevState => {
      return { hover: i };
    });
  }
}

const Down = styled.div`
  position: absolute;
  top: 90vh;
  left: calc(50vw - 12.5px);
  cursor: default;
  ${props => props.clicked !== 3 && "display: none;"}
`;

const Content = styled.div`
  display: block;
  ${props =>
    props.clicked !== props.number && props.clicked !== 3 && "display: none;"};
  text-align: center;
  margin-top: 25px;
  font-size: 21px;
  text-align: center;
  height: 100%;
`;

const Center = styled.div`
  display: none;
  ${props =>
    props.clicked !== props.number && props.clicked !== 3 && "display: block"};
  text-align: center;
`;

const ContentCard = styled.div`
    -webkit-transition: width .7s;
    transition: width .7s;
    color: white;
    height: 100%;
    cursor: ${props => props.clicked === props.number && "default"};
    ${props => (props.clicked === props.number ? "width: 92%" : "width: 4%")}

    ${props => props.clicked === 3 && "width: 33.3333%;"} 
    ${props =>
      props.color &&
      `background-color: rgba(${props.color}, ${
        props.clicked === props.number || props.hover === props.number
          ? "0.7"
          : "0.9"
      })`}
`;

const TitleWrap = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  ${props =>
    props.navHeight
      ? `height: calc(100vh - ${props.navHeight}px);`
      : "height: calc(100vh);"}
  background-image: url('./title.jpeg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  @media screen and (max-width: 800px) {
    display: none;
  }
`;

const Logo = styled.img`
  max-width: 80%;
  max-height: 59%;
  padding: 10%;
  ${props => props.clicked === 3 && "padding-top: calc(35vh);"}
`;

const Text = styled.div`
  display: ${props => (props.clicked === props.number ? "block" : "none")};
  margin: 0 10% 10% 10%;
`;
